import React from "react";
import MtiButton from "../../../../Buttons/MtiButton";
import Modal from "../../../../Common/Modal";

type Props = {
  show: boolean;
  onHide: () => void;
  doUseManualCalibration: () => void;
};

export default function UseManualCalibrationModal({
  show,
  onHide,
  doUseManualCalibration,
}: Props) {
  return (
    <Modal show={show} onHide={onHide} hideOnBackdropClick={false}>
      <Modal.Header
        title={"Use Manual Calibration"}
        hideButtonEnabled={false}
      />
      <Modal.Body
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontFamily: "Roboto",
        }}
      >
        <svg
          width="71"
          height="71"
          viewBox="0 0 71 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.4994 70.0837C54.5992 70.0837 70.0827 54.6002 70.0827 35.5003C70.0827 16.4005 54.5992 0.916992 35.4994 0.916992C16.3995 0.916992 0.916016 16.4005 0.916016 35.5003C0.916016 54.6002 16.3995 70.0837 35.4994 70.0837ZM28.5827 7.83366L32.041 42.417H38.9577L42.416 7.83366H28.5827ZM35.4994 63.167C39.3193 63.167 42.416 60.0703 42.416 56.2503C42.416 52.4304 39.3193 49.3337 35.4994 49.3337C31.6794 49.3337 28.5827 52.4304 28.5827 56.2503C28.5827 60.0703 31.6794 63.167 35.4994 63.167Z"
            fill="#F7A246"
          />
        </svg>
        <p
          style={{
            fontSize: 20,
            letterSpacing: 0.15,
            fontWeight: 600,
            color: "#F57E00",
            marginTop: 40,
            marginBottom: 0,
          }}
        >
          Are you sure to move as Manual Calibration?
        </p>
        <p
          style={{
            fontSize: 15,
            letterSpacing: 0.5,
            color: "#707070",
            marginTop: 10,
            marginBottom: 40,
          }}
        >
          If you choose it, so the value from auto calibration for selected
          carrier will overrided
        </p>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            columnGap: 20,
          }}
        >
          <MtiButton
            variant="secondary"
            size="large"
            onClick={onHide}
            style={{
              width: 157,
            }}
          >
            CANCEL
          </MtiButton>
          <MtiButton
            variant="primary"
            size="large"
            onClick={doUseManualCalibration}
            style={{
              width: 157,
            }}
          >
            YES, I AGREE
          </MtiButton>
        </div>
      </Modal.Body>
    </Modal>
  );
}
